import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServiceDetailsUIModel } from '../../../models/index';

const initialState: IServiceDetailsUIModel = {
  serviceName: '',
  endPoint: '',
  serviceType: '',
  serviceDescription: '',
  checkClicked: false,
  authDetails: {},
  soapAttributes: {},
  importStatus: false,
  timeOut: ''
};

const serviceDetailsSlice = createSlice({
  name: 'serviceDetails',
  initialState,
  reducers: {
    addServiceDetails: (state, action) => {
      state.serviceName = action.payload.serviceName;
      state.endPoint = action.payload.endPoint;
      state.serviceType = action.payload.serviceType;
      state.serviceDescription = action.payload.serviceDescription;
      state.checkClicked = action.payload.checkClicked;
      state.authDetails = action.payload.authDetails;
      state.soapAttributes = action.payload.soapAttributes;
      state.timeOut = action.payload.timeOut;
    },

    deleteServiceDetails: (state) => {
      state.serviceName = '';
      state.endPoint = '';
      state.serviceType = '';
      state.serviceDescription = '';
      state.checkClicked = false;
      state.authDetails = initialState.authDetails;
      state.soapAttributes = {};
      state.importStatus = false;
      state.timeOut = '';
    },
    updateImportStatus: (state, action) => {
      state.importStatus = action.payload;
    },
    checkProvideAuthenticationClicked: (state, action: PayloadAction<boolean>) => {
      state.checkClicked = action.payload;
    },
  }
});

export const {
  addServiceDetails,
  deleteServiceDetails,
  checkProvideAuthenticationClicked,
  updateImportStatus,
} = serviceDetailsSlice.actions;
export default serviceDetailsSlice.reducer;
